module.exports = __webpack_public_path__ + "static/media/mrPoot.0af10880.webp";